import { MenuFilter } from "@/common/MenuFilter";
import type { NotesTableColumnGetter, NotesTableColumnsProps } from "../types";
import type { NotesTableRowData } from "../types/notes-table-types";
import { NOTES_TABLE_COLUMNS_KEYS } from "../notes-table-columns-keys";
import { PersonTableRecord } from "../../ui";

export type NotesTablePersonColumnProps = NotesTableColumnsProps<{
  colorize?: boolean;
  menuFilters?: MenuFilter[];
  onChangeMenuFilters?: (selected: string[]) => void;
}>;

export type NotesTablePersonColumnGetter = NotesTableColumnGetter<NotesTablePersonColumnProps>;

export const getNotesTablePersonColumn: NotesTablePersonColumnGetter = ({
  title = "Person",
  width = 174,
  dataIndex = ["person"],
  colorize = false,
  key = NOTES_TABLE_COLUMNS_KEYS.person,
  onFilter = (value, record) => {
    return record?.person?.group?.includes(value as string) ?? false;
  },
  showSorterTooltip = false,

  menuFilters = [],
  onChangeMenuFilters = () => "",
  filterDropdown = () => <MenuFilter onChange={onChangeMenuFilters} filters={menuFilters} />,
  render = (_, record) => (
    <PersonTableRecord colorize={colorize} record={record as NotesTableRowData} />
  ),
  sorter = (a: NotesTableRowData, b: NotesTableRowData) =>
    (a?.person?.firstName as string)?.localeCompare(b?.person?.firstName as string),
  ...props
}) => {
  return {
    title: title,
    width: width,
    dataIndex: dataIndex,
    key: key,
    sorter: sorter,
    render: render,
    filterDropdown: filterDropdown,
    onFilter: onFilter,
    showSorterTooltip: showSorterTooltip,
    ...props,
  };
};
